import { Component, Input, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpeedOption } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/models/itinerary-options.model';
import { WALK_SPEED_OPTIONS } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/constants/walk-speed.constant';
import { MAX_WALK_TIME_OPTIONS } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/constants/max-walk-time-options.constant';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-walk-form',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, MatSelectModule, ReactiveFormsModule, MatInputModule, MatCheckboxModule],
  templateUrl: './walk-form.component.html',
  styleUrls: ['./walk-form.component.scss']
})
export class WalkFormComponent {

  public maxWalkTimeOptions = MAX_WALK_TIME_OPTIONS;
  public walkSpeedOptions = WALK_SPEED_OPTIONS

  @Input({required: true}) walkSpeed!: WritableSignal<SpeedOption>;
  @Input({required: true}) wheelchairAccessible!: WritableSignal<boolean>;

}
